document.addEventListener('DOMContentLoaded', function() {
  // Create global style element immediately to ensure our styles take precedence
  const styleId = 'variant-preserve-style';
  if (!document.getElementById(styleId)) {
    const styleEl = document.createElement('style');
    styleEl.id = styleId;
    styleEl.innerHTML = `
      /* Prevent transitions during variant changes with high specificity */
      body.variant-changing .variant-swatch-list,
      body.variant-changing .variant-swatch-list * {
        transition: none !important;
      }
      
      /* Force expanded state to remain visible during transitions */
      .variant-swatch-list[data-preserve-expanded="true"] {
        max-height: 1000px !important;
        transition: none !important;
        overflow: visible !important;
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(styleEl);
  }
  
  initVariantSwatchToggle();
  
  // Handle variant changes with multiple safety measures
  document.addEventListener('variant:changed', function(event) {
    // Immediately preserve state before any DOM update
    const containers = document.querySelectorAll('.variant-swatch-list-container');
    containers.forEach(container => {
      const variantList = container.querySelector('.variant-swatch-list');
      if (variantList && variantList.classList.contains('is-expanded')) {
        // Force expanded state with multiple techniques
        variantList.setAttribute('data-preserve-expanded', 'true');
        variantList.style.maxHeight = '1000px';
        variantList.style.transition = 'none';
        variantList.style.overflow = 'visible';
        variantList.style.opacity = '1';
        
        // Store in session for persistence
        const productId = container.closest('[data-section-id]')?.getAttribute('data-section-id') || 'default';
        sessionStorage.setItem(`variant-expanded-${productId}`, 'true');
      }
    });
    
    // Add class to prevent transitions during the entire variant change process
    document.body.classList.add('variant-changing');
    
    // Use requestAnimationFrame for smoother visual handling
    requestAnimationFrame(() => {
      // First frame to ensure styles are applied
      initVariantSwatchToggle(true);
      
      // Use another animation frame to handle the cleanup
      requestAnimationFrame(() => {
        setTimeout(() => {
          // Only remove variant-changing class after everything is done
          document.body.classList.remove('variant-changing');
        }, 100); // Additional delay to ensure DOM is settled
      });
    });
  });
});

function initVariantSwatchToggle(isVariantChange = false) {
  const containers = document.querySelectorAll('.variant-swatch-list-container');
  
  containers.forEach(container => {
    const variantList = container.querySelector('.variant-swatch-list');
    const toggleButton = container.querySelector('.variant-swatch-toggle__button');
    
    // If there's nothing to toggle, skip
    if (!toggleButton || !variantList) return;
    
    // Remove previous event listeners to prevent duplicates
    const newButton = toggleButton.cloneNode(true);
    if (toggleButton.parentNode) {
      toggleButton.parentNode.replaceChild(newButton, toggleButton);
    }
    
    // Check for persistent storage state or preserved attribute
    const productId = container.closest('[data-section-id]')?.getAttribute('data-section-id') || 'default';
    const shouldBeExpanded = 
      variantList.hasAttribute('data-preserve-expanded') || 
      sessionStorage.getItem(`variant-expanded-${productId}`) === 'true';
      
    // Apply expanded state - avoid animation during variant changes
    if (shouldBeExpanded) {
      // Apply multiple styles for maximum override effect
      variantList.style.transition = 'none';
      variantList.style.maxHeight = '1000px';
      variantList.style.overflow = 'visible';
      variantList.classList.add('is-expanded');
      newButton.setAttribute('aria-expanded', 'true');
      
      // Force a reflow to ensure styles apply immediately
      void variantList.offsetWidth;
      
      // Only clean up if this isn't part of a variant change
      if (!isVariantChange) {
        // Remove the data attribute after a delay
        setTimeout(() => {
          if (variantList.isConnected) {
            variantList.removeAttribute('data-preserve-expanded');
            variantList.style.transition = '';
            // Don't remove the maxHeight style to maintain expanded state
          }
        }, 200);
      }
    } else {
      variantList.classList.remove('is-expanded');
      newButton.setAttribute('aria-expanded', 'false');
    }
    
    // Add click event for toggle button
    newButton.addEventListener('click', function() {
      const isExpanded = !variantList.classList.contains('is-expanded');
      
      if (isExpanded) {
        // Expanding - add class first then apply styles
        variantList.classList.add('is-expanded');
        newButton.setAttribute('aria-expanded', 'true');
        
        // Apply same multiple styles when manually expanding
        variantList.style.maxHeight = '1000px';
        variantList.style.transition = '';
        variantList.style.overflow = 'visible';
        sessionStorage.setItem(`variant-expanded-${productId}`, 'true');
      } else {
        // Collapsing - remove styles first to enable proper animation
        variantList.style.maxHeight = '';
        variantList.style.overflow = '';
        
        // Force reflow before removing class to ensure proper transition
        void variantList.offsetWidth;
        
        // Now remove the class, which triggers the transition
        variantList.classList.remove('is-expanded');
        newButton.setAttribute('aria-expanded', 'false');
        sessionStorage.removeItem(`variant-expanded-${productId}`);
        
        // Make sure the transition is enabled for collapse
        variantList.style.transition = 'max-height 0.3s ease';
      }
    });
  });
}